export const API_URL = 'https://учимед.рф';
export const BASE_URL_PURCHASE = 'https://learnmed.ru/resource';
